import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import Delete from "@mui/icons-material/Delete";
import deleteJobRequest from "../utils/deleteJobRequest";
import deleteMessage from "../utils/deleteMessage";
import useUserProfile from "../customhooks/useUserProfile";
import Notification from "../components/Notification";
import deleteSubscription from "../utils/deleteSubscription";

export default function ConfirmDialog(props) {
  const {
    confirmDialog,
    setConfirmDialog,
    refreshFunc,
    message,
    whatToDelete,
  } = props;
  const userProfile = useUserProfile();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const handleClose = async (remove) => {
    if (remove) {
      if (whatToDelete === "ad") {
        await deleteJobRequest({ id: confirmDialog.id });
      } else if (whatToDelete === "message") {
        await deleteMessage({ id: confirmDialog.id });
      } else if (whatToDelete === "subscription") {
        await deleteSubscription({ id: confirmDialog.id });
      }
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });
      const postpone = () => {
        refreshFunc({ userId: userProfile.id });
      };
      setTimeout(postpone, 1000);
      setNotify({ isOpen: true, message: message, type: "success" });
    } else {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });
    }
  };
  return (
    <>
      <Dialog open={confirmDialog.isOpen}>
        <DialogTitle>
          <Typography variant="h6" component="div">
            {confirmDialog.title}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle2">{confirmDialog.subtitle}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Avbryt</Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Delete />}
            onClick={() => handleClose(true)}
          >
            Ta bort
          </Button>
        </DialogActions>
      </Dialog>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
